// extracted by mini-css-extract-plugin
export var wrapper = "Contacts-module--wrapper--11d90";
export var column = "Contacts-module--column--80104";
export var contact = "Contacts-module--contact--832b2";
export var icon = "Contacts-module--icon--9bb31";
export var contactText = "Contacts-module--contactText--15ff4";